import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import Button from '@wix/da-shared-react/pkg/Button';
import ThumbInfo from '@wix/da-shared-react/pkg/ThumbInfo';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import {
  getDeviationType,
  getDeviationResourceType,
} from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';
import DeviationPaywall from '../../_partials/paywalls/DeviationPaywall';

import s from './FeaturedDeviationThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  isMobile?: boolean;
  showMatureContent?: boolean;
}

export const FeaturedDeviationThumb: React.SFC<Props & WithTranslation> = ({
  deviation: { title, author, deviationId, printId },
  deviation,
  width,
  height,
  t,
}) => {
  const isMobile = useContext(MobileContext);
  const { pointPrice, folderId } = normalizePremiumFolderData(
    deviation.premiumFolderData
  );

  return (
    <div className={s['root']}>
      <ErrorBoundary>
        <DeviationPaywall
          isLiterature={
            getDeviationType(deviation) === DeviationTypes.LITERATURE
          }
          premiumFolderData={deviation.premiumFolderData}
          contentOwner={deviation.author!}
          biData={{
            evid: BiEventType.GALLERY_PURCHASE,
            points: pointPrice,
            typeid: getDeviationResourceType(deviation),
            itemid: deviationId,
            galleryid: folderId,
            authorid: author && author.useridUuid, // This is NOT the gallery owner
          }}
        >
          <OverlayContext.Consumer>
            {value => (
              <OverlayContext.Provider
                value={{
                  ...value,
                  showAuthor: false,
                  showTitle: false,
                }}
              >
                <StandardThumb
                  deviation={deviation}
                  width={width}
                  height={height}
                />
              </OverlayContext.Provider>
            )}
          </OverlayContext.Consumer>
        </DeviationPaywall>
        <ThumbInfo
          height={82}
          urlDeviation={deviation}
          user={author!}
          title={title}
          extra={
            !!printId && (
              <Button
                className={classnames(!isMobile && s['btn-buy'])}
                view="b18"
                height="small"
                href={Url.printLink(deviationId!)}
              >
                {t('common.buy')}
              </Button>
            )
          }
        />
      </ErrorBoundary>
    </div>
  );
};
FeaturedDeviationThumb.displayName = 'FeaturedDeviationThumb';

export default withTranslation()(FeaturedDeviationThumb);
